import { render, staticRenderFns } from "./search.vue?vue&type=template&id=7a59134b"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/opt/build/repo/frontend/components/header/headerDefault.vue').default,ExploreResultsDefault: require('/opt/build/repo/frontend/components/blocks/exploreResultsDefault.vue').default})
